import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';
import { format } from "date-fns";

class ModelSetOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            isHaveModel:false,
            drawMode : "0",
            scale : 1,
            cover : "null",
            helpMode : "None",
            isNoiceOpen : true
        };
        this.setEntityColor=this.setEntityColor.bind(this);
    }
    componentWillMount(){
        const layer = this.props.layer;
        var ModelSetLayer = this.props.layer.layerHandel;
        if(layer.layerMode!=null){
            if (layer.layerMode) {
                ModelSetLayer.setDrawMode(1, 3);
                this.setState({drawMode:"0",isHaveModel:true});
            } else{
                ModelSetLayer.setDrawMode(0, 0);
                this.setState({drawMode:"1",isHaveModel:false});
            }            
        }
        if(this.state.isNoiceOpen){
            this.setEntityColor();
        }
    }
    deleteLayerList(layer){
        const Layer = {
            GROUP:layer.group,
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        if(this.props.layer.layerLocation!=null){
            var Pos = new window.Geo3DPoint(this.props.layer.layerLocation.POS.x , this.props.layer.layerLocation.POS.y , this.props.layer.layerLocation.POS.z);
            var V = new window.Geo3DPoint(this.props.layer.layerLocation.V.x , this.props.layer.layerLocation.V.y , this.props.layer.layerLocation.V.z);
            var Up = new window.Geo3DPoint(this.props.layer.layerLocation.UP.x , this.props.layer.layerLocation.UP.y , this.props.layer.layerLocation.UP.z);
            var Camera = new window.ov.Camera(Pos,V,Up);
            window.main.OView.gotoCamera(Camera, true);
        }
        else{
            var ModelSetLayer = this.props.layer.layerHandel;
            ModelSetLayer.goto();
        }
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    coverChange(event){
        var cover = event.target.value;
        var ModelSetLayer = this.props.layer.layerHandel;
        if(cover === "null"){
            ModelSetLayer.setOverlayName([]);
            window.main.OView.updateScreen();
        }            
        else{
            ModelSetLayer.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    NoiceToggleOpen(){
        var ModelSetLayer = this.props.layer.layerHandel;
        if(this.state.isNoiceOpen){
            ModelSetLayer.removeEntityColorFunction();       
        }
        this.setState({isNoiceOpen:!this.state.isNoiceOpen});
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.currentTime!==this.props.currentTime || prevState.isNoiceOpen!==this.state.isNoiceOpen){
            this.setEntityColor();
            this.changeNoiceInfo();
        }
    }
    changeNoiceInfo(){
        const layerThis = this;
        if (layerThis.props.layer.timeLine !== undefined) {
            let attr = layerThis.props.infoBoxAttr;
            
            let time = format(layerThis.props.layer.timeLine.SELECTEDINTERVAL[0],'yyyyMMddHH');
            if (layerThis.props.currentTime.length != 0)
                time = format(layerThis.props.currentTime[0],'yyyyMMddHH');
            let data = window.BuildNoice;
            if (attr.ATTR.length != 0) {
                let layerId = layerThis.props.layer.id;
                if (data.hasOwnProperty(layerId)) {
                    let building_id = attr.ATTR[1]+"_"+attr.ATTR[3];
                    if (data[layerId][time].hasOwnProperty(building_id)) {
                        attr.ATTR[4] = data[layerId][time][building_id];
                    } else {
                        attr.ATTR[4] = "無資料";
                    }
                    layerThis.props.setinfoBox(attr);
                } else {
                    layerThis.props.layer.layerHandel.getColAndAttrs(attr.ATTR[0], function(attrs) {
                        attr.ATTR[4] = "無資料";
                        layerThis.props.setinfoBox(attrs);
                    });
                }
            }
        }
    }
    setEntityColor(){
        if (this.props.layer.timeLine !== undefined) {
            let ModelSetLayer = this.props.layer.layerHandel;
            let time = format(this.props.layer.timeLine.SELECTEDINTERVAL[0],'yyyyMMddHH');
            if (this.props.currentTime.length != 0)
                time = format(this.props.currentTime[0],'yyyyMMddHH');
            let data = window.BuildNoice;
            if (this.state.isNoiceOpen) {
                let layerId = this.props.layer.id;
                ModelSetLayer.setEntityColorFunction(["NO", "floors", "noice"], function (id, Attrs, color) {
                    let building_id = Attrs[0] + "_" + Attrs[1];
                    let noice = 0;
                    if (data.hasOwnProperty(layerId)) {
                        if (data[layerId][time].hasOwnProperty(building_id))
                            noice = data[layerId][time][building_id];
                    }

                    if (noice < 30) {
                        color[0] = 26;  // R
                        color[1] = 150; // G
                        color[2] = 65;  // B
                        color[3] = 255; // A
                    } else if (noice < 35 && noice >= 30) {
                        color[0] = 73;
                        color[1] = 188;
                        color[2] = 62;
                        color[3] = 255;
                    } else if (noice < 40 && noice >= 35) {
                        color[0] = 166;
                        color[1] = 217;
                        color[2] = 106;
                        color[3] = 255;
                    } else if (noice < 45 && noice >= 40) {
                        color[0] = 207;
                        color[1] = 229;
                        color[2] = 106;
                        color[3] = 255;
                    } else if (noice < 50 && noice >= 45) {
                        color[0] = 248;
                        color[1] = 235;
                        color[2] = 135;
                        color[3] = 255;
                    } else if (noice < 55 && noice >= 50) {
                        color[0] = 255;
                        color[1] = 206;
                        color[2] = 89;
                        color[3] = 255;
                    } else if (noice < 60 && noice >= 55) {
                        color[0] = 251;
                        color[1] = 162;
                        color[2] = 91;
                        color[3] = 255;
                    } else if (noice < 65 && noice >= 60) {
                        color[0] = 251;
                        color[1] = 121;
                        color[2] = 20;
                        color[3] = 255;
                    } else if (noice < 70 && noice >= 65) {
                        color[0] = 251;
                        color[1] = 65;
                        color[2] = 102;
                        color[3] = 255;
                    } else if (noice < 75 && noice >= 70) {
                        color[0] = 234;
                        color[1] = 23;
                        color[2] = 47;
                        color[3] = 255;
                    } else if (noice < 80 && noice >= 75) {
                        color[0] = 187;
                        color[1] = 21;
                        color[2] = 46;
                        color[3] = 255;
                    } else if (noice < 85 && noice >= 80) {
                        color[0] = 143;
                        color[1] = 21;
                        color[2] = 46;
                        color[3] = 255;
                    } else if (noice >= 85) {
                        color[0] = 88;
                        color[1] = 21;
                        color[2] = 46;
                        color[3] = 255;
                    } else {
                        color[0] = 255; // R
                        color[1] = 255; // G
                        color[2] = 255; // B
                        color[3] = 255; // A
                        // 不符合的圖素白色
                    }    
                    return true; // 回傳值為true則顯示，false則隱藏圖素
                });
            }
        }
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        if(this.state.helpMode === "ModelSetHelp" ){
            if(this.state.isHaveModel){
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/35jBgg2fzDw" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));

            }
            else{
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/0zpCYGzrjGw" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
            }
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large building icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("ModelSetHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen?
                    <div className="ts very narrow container segment" >
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">影像披覆：</h6>
                            </div>
                            <div className="ts six wide column">
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.coverChange(e)} value={this.state.cover} style={{width:"100%"}}>
                                    <option value="null">無</option>
                                    {
                                        LayerList_2D.map(
                                            (layer)=>
                                                <option value={layer.layerName}>{layer.layerName}</option> 
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">噪音程度上色：</h6>
                            </div>
                            <div className="ts six wide column">
                                <div class="ts toggle checkbox">
                                    <input type="checkbox" id={Layer.layerName + "NoiceToggle"} checked={this.state.isNoiceOpen} onClick={(e)=>this.NoiceToggleOpen()}></input>
                                    <label for={Layer.layerName + "NoiceToggle"}></label>
                                </div>
                            </div>
                        </div>
                    </div> : null
                }                
            </div>
        );
    }
}

class ModelSetLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            modelSetLayer:{}
        };   
        this.modelSetLayerChecked = this.modelSetLayerChecked.bind(this);      
    }
    componentDidMount(){
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.modelSetLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,modelSetLayer:{}});
            }            
        }
    }
    divTime(time){
        let time1 = Date.parse(time[0]);
        let time2 = Date.parse(time[1]);
        return Math.abs(parseInt((time2 - time1) / 1000 / 3600));
    }
    getNoiseData(){
        let layer = this.props.layer;
        let dt_s = format(layer.TIMELINE.TIMElINEINTERVAL[0],'yyyyMMddHH');
        let range = this.divTime(layer.TIMELINE.TIMElINEINTERVAL);
        // let range = 3;
        const d = {
            type: "building",
            area: layer.ID,
            dt_s: dt_s,
            range: range
        };
        const formData = Object.keys(d).map(function (keyName) {
            return encodeURIComponent(keyName) + '=' + encodeURIComponent(d[keyName])
        }).join('&');
        if (!window.BuildNoice.hasOwnProperty(layer.ID)) {
            if (layer.FETCHURL !== undefined) {
                fetch(layer.FETCHURL, {
                        method: "POST",
                        body: formData,
                        headers: new Headers({
                            "Content-type": "application/x-www-form-urlencoded"
                        })
                    })
                    .then(res => res.json())
                    .then(data => {
                        Object.assign(window.BuildNoice, data);
                    })
                    .catch(e => {
                        console.log(e);
                        console.log("取得資料失敗");
                    })
            }
        }
    }
    modelSetLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            if (layer.LEGEND !== undefined) {
                this.getNoiseData();
            }
            window.main.OView.addModelSetLayer({
                url: window.LOCAL_SERVER.URL,
                identifier: layer.ID,
                urlTemplate: window.LOCAL_SERVER.URLTemplate,
                callback: function (e,modelSetLayer) {
                    if(e){
                        modelSetLayer.setUseLight(false);
                        modelSetLayer.setOnClickEntity(function(id, pos) {
                            modelSetLayer.getColAndAttrs(id, function(attrs) {
                                let time = format(layer.TIMELINE.SELECTEDINTERVAL[0],'yyyyMMddHH');
                                if (layerThis.props.currentTime.length != 0)
                                    time = format(layerThis.props.currentTime[0],'yyyyMMddHH');
                                let data = window.BuildNoice;
                                attrs.ATTR[4] = "無資料";
                                if (data.hasOwnProperty(layer.ID)) {
                                    let building_id = attrs.ATTR[1]+"_"+attrs.ATTR[3];
                                    if (data[layer.ID][time].hasOwnProperty(building_id)) {
                                        attrs.ATTR[4] = data[layer.ID][time][building_id];
                                    }
                                }
                                layerThis.props.setinfoBoxOpen();
                                layerThis.props.setinfoBox(attrs);
                            });
                        });
                        if(layer.LOCATION!=null){
                            var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x , layer.LOCATION.POS.y , layer.LOCATION.POS.z);
                            var V = new window.Geo3DPoint(layer.LOCATION.V.x , layer.LOCATION.V.y , layer.LOCATION.V.z);
                            var Up = new window.Geo3DPoint(layer.LOCATION.UP.x , layer.LOCATION.UP.y , layer.LOCATION.UP.z);
                            var Camera = new window.ov.Camera(Pos,V,Up);
                            window.main.OView.gotoCamera(Camera, true);
                        }
                        else{
                            modelSetLayer.goto();
                        }
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,modelSetLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({ isChecked: isChecked, modelSetLayer: modelSetLayer });
                        if (layer.LEGEND !== undefined)
                            layerThis.props.setLegendBoxContent(layer.LEGEND);
                        if (layer.TIMELINE !== undefined)
                            layerThis.props.setTimeLineContent(layer.TIMELINE);
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });               
        }
        else{
            window.main.OView.removeLayer(this.state.modelSetLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;
            layerThis.setState({isChecked:isChecked,modelSetLayer:{}});
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="ModelSetLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.modelSetLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {ModelSetLayer,ModelSetOption};